//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  auth: false,
  components: {
    Slick: () => import('vue-slick')
  },
  layout: 'front-page',
  data () {
    return {
      openTab: 1,
      itemBlogs: [],
      itemArtikel: [],
      itemSliders: [],
      page: 1,
      last_page: 1,
      slickComp: '',
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: false
      },
      search: '',
      listWatch: false,
      sourceCancel: null
    }
  },
  watch: {
    search: {
      async handler () {
        if (this.listWatch) {
          this.sourceCancel.cancel()
          this.page = 1
          this.itemBlogs = []
          await this.loadData(this.openTab)
        }
      }
    }
  },
  async mounted () {
    await this.loadData(1)
    await this.loadArtikel()
    await this.loadSlider()
    this.$nextTick(function () {
      this.slickComp = 'Slick'
    })
  },
  methods: {
    test (item) {
      console.log(item)
    },
    toggleTabs (tabNumber) {
      this.openTab = tabNumber
      this.page = 1
      this.itemBlogs = []
      this.loadData(tabNumber)
    },
    more (tabNumber) {
      this.page++
      this.loadData(tabNumber)
    },
    async loadData (cat) {
      const { CancelToken } = this.$axios
      this.sourceCancel = CancelToken.source()

      let params = { page: this.page, per_page: 4, search: this.search }
      if (cat !== 1) {
        let nameCat = ''
        if (cat === 2) {
          nameCat = 'Kesehatan'
        } else if (cat === 3) {
          nameCat = 'Tips & Trick'
        } else if (cat === 4) {
          nameCat = 'Kecantikan'
        } else if (cat === 5) {
          nameCat = 'Gaya Hidup'
        } else {
          nameCat = 'Review'
        }
        params = { category: nameCat, per_page: 4, search: this.search }
      }

      await this.$axios
        .$get('/api/blog/list', {
          params,
          cancelToken: this.sourceCancel.token
        })
        .then((data) => {
          this.itemBlogs.push(...data.data)
          this.last_page = data.last_page
        })
        .catch(() => {})
        .finally(() => {
          this.listWatch = true
        })
    },
    async loadArtikel () {
      const params = { per_page: 4, search: this.search }

      await this.$axios
        .$get('/api/blog/list', {
          params
        })
        .then((data) => {
          this.itemArtikel = data.data
        })
        .catch(() => {})
        .finally(() => {})
    },
    async loadSlider () {
      const params = { per_page: 4 }

      await this.$axios
        .$get('/api/blog/list', {
          params
        })
        .then((data) => {
          const cutBlog = data.data.slice(0, 4)
          this.itemSliders = cutBlog
        })
        .catch(() => {})
        .finally(() => {})
    }
  }
}
